const WidgetConfigHintImage = () => {
  return (
    <svg width="149" height="140" viewBox="0 0 149 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3361_120303)">
        <rect
          x="-65.75"
          y="21.25"
          width="175.5"
          height="126.5"
          rx="4.75"
          fill="#F3F4FC"
          stroke="#1C1C21"
          strokeWidth="1.5"
        />
        <g opacity="0.7">
          <rect x="45.7168" y="47.2373" width="40.9072" height="23.0928" rx="1.97938" fill="#E7E9F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.3495 55.9824C68.6919 55.9824 68.9721 56.2626 68.9721 56.6051V60.9637C68.9721 61.3062 68.6919 61.5864 68.3495 61.5864H63.9908C63.6484 61.5864 63.3682 61.3062 63.3682 60.9637V56.6051C63.3682 56.2626 63.6484 55.9824 63.9908 55.9824H68.3495ZM65.8588 60.1885L65.0805 59.2514L63.9908 60.6524H68.3495L66.9485 58.7844L65.8588 60.1885Z"
            fill="#F3F4FC"
          />
          <rect x="45.7168" y="73.6289" width="40.9072" height="3.29897" rx="1.64948" fill="#E7E9F9" />
          <rect x="45.7168" y="78.9072" width="28.4868" height="3.29897" rx="1.64948" fill="#E7E9F9" />
        </g>
        <g opacity="0.7">
          <rect x="-6.07666" y="90.124" width="40.9072" height="23.0928" rx="1.97938" fill="#E7E9F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5565 98.8682C16.899 98.8682 17.1792 99.1484 17.1792 99.4908V103.849C17.1792 104.192 16.899 104.472 16.5565 104.472H12.1979C11.8554 104.472 11.5752 104.192 11.5752 103.849V99.4908C11.5752 99.1484 11.8554 98.8682 12.1979 98.8682H16.5565ZM14.0658 103.074L13.2875 102.137L12.1979 103.538H16.5565L15.1555 101.67L14.0658 103.074Z"
            fill="#F3F4FC"
          />
          <rect x="-6.07666" y="116.516" width="40.9072" height="3.29897" rx="1.64948" fill="#E7E9F9" />
          <rect x="-6.07666" y="121.794" width="28.4868" height="3.29897" rx="1.64948" fill="#E7E9F9" />
        </g>
        <g opacity="0.7">
          <rect x="45.7168" y="90.124" width="40.9072" height="23.0928" rx="1.97938" fill="#E7E9F9" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.3495 98.8682C68.6919 98.8682 68.9721 99.1484 68.9721 99.4908V103.849C68.9721 104.192 68.6919 104.472 68.3495 104.472H63.9908C63.6484 104.472 63.3682 104.192 63.3682 103.849V99.4908C63.3682 99.1484 63.6484 98.8682 63.9908 98.8682H68.3495ZM65.8588 103.074L65.0805 102.137L63.9908 103.538H68.3495L66.9485 101.67L65.8588 103.074Z"
            fill="#F3F4FC"
          />
          <rect x="45.7168" y="116.516" width="40.9072" height="3.29897" rx="1.64948" fill="#E7E9F9" />
          <rect x="45.7168" y="121.794" width="28.4868" height="3.29897" rx="1.64948" fill="#E7E9F9" />
        </g>
        <rect x="-6.07666" y="47.2373" width="40.9072" height="23.0928" rx="1.97938" fill="#E7E9F9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5565 55.9824C16.899 55.9824 17.1792 56.2626 17.1792 56.6051V60.9637C17.1792 61.3062 16.899 61.5864 16.5565 61.5864H12.1979C11.8554 61.5864 11.5752 61.3062 11.5752 60.9637V56.6051C11.5752 56.2626 11.8554 55.9824 12.1979 55.9824H16.5565ZM14.0658 60.1885L13.2875 59.2514L12.1979 60.6524H16.5565L15.1555 58.7844L14.0658 60.1885Z"
          fill="#F3F4FC"
        />
        <rect x="-6.07666" y="73.6289" width="40.9072" height="3.29897" rx="1.64948" fill="#E7E9F9" />
        <rect x="-6.07666" y="78.9072" width="28.4868" height="3.29897" rx="1.64948" fill="#E7E9F9" />
      </g>
      <g filter="url(#filter1_d_3361_120303)">
        <circle cx="90.8516" cy="121" r="10" fill="#7E05FE" />
        <rect width="6.66667" height="6.66667" transform="translate(87.5181 117.667)" fill="#7E05FE" />
        <path
          d="M90.8434 122.719C90.9248 122.719 91.0062 122.686 91.0615 122.624L93.5811 120.043C93.6364 119.988 93.6689 119.916 93.6689 119.835C93.6689 119.665 93.542 119.535 93.3727 119.535C93.2913 119.535 93.2165 119.568 93.1611 119.62L90.8434 121.99L88.5225 119.62C88.4704 119.568 88.3955 119.535 88.3109 119.535C88.1416 119.535 88.0146 119.665 88.0146 119.835C88.0146 119.916 88.0472 119.988 88.1025 120.046L90.6221 122.624C90.6839 122.686 90.7588 122.719 90.8434 122.719Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_3361_120303)">
        <rect x="41" y="10" width="60" height="96" rx="3.95876" fill="white" />
      </g>
      <path
        d="M44 54.9794C44 53.8862 44.8862 53 45.9794 53H82.0206C83.1138 53 84 53.8862 84 54.9794V60.0206C84 61.1138 83.1138 62 82.0206 62H44V54.9794Z"
        fill="#F3F4FC"
      />
      <rect x="46.3779" y="58.4121" width="22.1252" height="1.64948" rx="0.824742" fill="white" />
      <rect x="46.3779" y="55.1133" width="25.5291" height="1.64948" rx="0.824742" fill="white" />
      <path
        d="M44 64H82.0206C83.1138 64 84 64.8862 84 65.9794V72.0206C84 73.1138 83.1138 74 82.0206 74H45.9794C44.8862 74 44 73.1138 44 72.0206V64Z"
        fill="#F3F4FC"
      />
      <rect x="46.3779" y="69.959" width="22.1252" height="1.64948" rx="0.824742" fill="white" />
      <rect x="46.3774" y="66.6602" width="25.5291" height="1.64948" rx="0.824742" fill="white" />
      <g filter="url(#filter3_d_3361_120303)">
        <path
          d="M72 36.9794C72 35.8862 72.8862 35 73.9794 35H120.021C121.114 35 122 35.8862 122 36.9794V49H73.9794C72.8862 49 72 48.1138 72 47.0206V36.9794Z"
          fill="#7E05FE"
        />
        <rect opacity="0.2" x="74.8516" y="40.9482" width="20" height="2" rx="1" fill="#F3F4FC" />
        <rect opacity="0.2" x="74.8516" y="43.9482" width="26" height="2" rx="1" fill="#F3F4FC" />
        <rect opacity="0.2" x="74.8516" y="37.9482" width="35" height="2" rx="1" fill="#F3F4FC" />
      </g>
      <g filter="url(#filter4_d_3361_120303)">
        <path
          d="M65 78.9794C65 77.8862 65.8862 77 66.9794 77H113.021C114.114 77 115 77.8862 115 78.9794V91H66.9794C65.8862 91 65 90.1138 65 89.0206V78.9794Z"
          fill="#7E05FE"
        />
        <rect opacity="0.2" x="67.8516" y="82.9482" width="28" height="2" rx="1" fill="#F3F4FC" />
        <rect opacity="0.2" x="67.8516" y="85.9482" width="21" height="2" rx="1" fill="#F3F4FC" />
        <rect opacity="0.2" x="67.8516" y="79.9482" width="25" height="2" rx="1" fill="#F3F4FC" />
      </g>
      <rect x="55.2847" y="15.5049" width="29.0309" height="1.97938" rx="0.989691" fill="#E7E9F9" />
      <rect x="55.2847" y="19.2607" width="19.7938" height="1.97938" rx="0.989691" fill="#E7E9F9" />
      <circle cx="48.6869" cy="18.474" r="4.61856" fill="#E7E9F9" />
      <defs>
        <filter
          id="filter0_d_3361_120303"
          x="-111.643"
          y="6.97423"
          width="260.619"
          height="177.582"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="7.91753" />
          <feGaussianBlur stdDeviation="10.7216" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3361_120303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3361_120303" result="shape" />
        </filter>
        <filter
          id="filter1_d_3361_120303"
          x="60.8516"
          y="91"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.447059 0 0 0 0 0.470588 0 0 0 0 0.533333 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3361_120303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3361_120303" result="shape" />
        </filter>
        <filter
          id="filter2_d_3361_120303"
          x="19.5567"
          y="-3.52577"
          width="102.887"
          height="138.887"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="7.91753" />
          <feGaussianBlur stdDeviation="10.7216" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3361_120303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3361_120303" result="shape" />
        </filter>
        <filter
          id="filter3_d_3361_120303"
          x="59.1504"
          y="26.8949"
          width="75.6991"
          height="39.6991"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.74445" />
          <feGaussianBlur stdDeviation="6.42478" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3361_120303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3361_120303" result="shape" />
        </filter>
        <filter
          id="filter4_d_3361_120303"
          x="52.1504"
          y="68.8949"
          width="75.6991"
          height="39.6991"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.74445" />
          <feGaussianBlur stdDeviation="6.42478" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0 0.145098 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3361_120303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3361_120303" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default WidgetConfigHintImage;
